import _ from 'lodash'
import axios from 'axios';
import { matrixMapping } from '../helpers/basket-items'
// import instructionSchema from '~/schemas/instructions.schema'
import stockOrderSchema from '../schemas/stock-order.schema'
import manpackOrderSchema from '../schemas/manpack-order.schema'
import formatCurrency from '../filters/currency'
import resetStore from '../helpers/reset-store'
import { convertBasketItems } from '../helpers/basket-items'
import { addManpackBasketItemToState } from '../helpers/add-wearer-basket-item.js'
import store from '@/store' // adjust this path if your store is in a different folder

export const state = () => ({
  // Standard basket for user
  basket: [],
  // Manpack for basket
  manpacks: [],
  stockOrder: [],
  manpackItems: [],
  matrixMapping: matrixMapping,
  instructions: {
    stock: {},
    manpack: {}
  },
  splitFeeItem: null, // <-- ADD THIS: To store the split fee charge item
  addresses: [],
  shipMethods: [],
  customAddressSet: null,
  // Address sync tracking
  initialAddressCount: 0,
  addressesPosted: 0,
  paymentMethods: {
    type: 1, // 1: Trade account || 2: Instant payment
    signature: null,
    card: {},
    sessionkey: null,
    paymentInput: {
      name: '',
      cardNumber: '',
      expiryMonth: '',
      expiryYear: '',
      type: 'Card',
      cvc: ''
    }
  },
  verifyPrices: true,
  // Selected basket type across all basket-related pages
  selectedBasketType: 'stock-order-basket',
  // Track if user has visited basket page (allows checkout access)
  hasVisitedBasket: false,
  // Track if user chose to consolidate deliveries
  consolidateDelivery: true,
  basketIdForApproval: null,
  approvedOrderAddressId: null,
  approvedOrderDetails: null,
  punchoutLoadedBasket: null
})


export const getters = {
  /**
   * New Getter 1: Determines if the basket has items with different lead times.
   */
  canCombine(state, getters) {
    const products = getters.stockOrderProducts; // Assuming you have a getter that returns stock products
    if (!products || products.length < 2) {
      return false;
    }
    const getLeadTimeValue = (product) => _.get(product, 'custitem_smi_no_del_days.value');
    const uniqueLeadTimes = _.uniq(products.map(getLeadTimeValue));
    return uniqueLeadTimes.length > 1;
  },
  approvedOrderAddressId: state => state.approvedOrderAddressId,
  basketIdToApprove: state => state.basketIdToApprove,
  approvedOrderDetails: state => state.approvedOrderDetails,

  /**
   * New Getter 2: Calculates the split delivery fee.
   */
  splitDeliveryFee(state, getters) {
    // Uses the 'canCombine' getter and checks the 'consolidateDelivery' state
    if (getters.canCombine && !state.consolidateDelivery && state.splitFeeItem) {
      return state.splitFeeItem.price || 0;
    }
    return 0; // Otherwise, the fee is zero.
  },
  basketCount: state => {
    let items = convertBasketItems(state.stockOrder, state.basket)

    let productArray = []

    for (let singleProduct of items) {
      if (singleProduct.custitem_smi_mysmi_remove_item) {
        if (singleProduct.custitem_smi_mysmi_remove_item.value === true) {
          productArray.push(singleProduct.id)
        }
      }
    }

    const filteredArray = state.basket.filter(
      item => !productArray.includes(item.productId)
    )

    state.basket = filteredArray

    const totalStandard = _.sumBy(state.basket, 'qty')
    const totalManpack = _.sumBy(state.manpacks, manpack => {
      return _.sumBy(manpack.data, 'qty')
    })

    return {
      total: totalStandard + totalManpack,
      stock: totalStandard,
      manpack: totalManpack
    }
  },
  hasTwoOrders(state) {
    return state.basket.length && state.manpacks.length
  },
  getQtyById: state => (productId, employeeId = false) => {
    if (!employeeId) {
      return state.basket.find(line => {
        if (line.productId === productId) {
          return line.qty
        } else {
          return 0
        }
      })
    } else {
      const manpack = state.manpacks.find(manpack => {
        if (manpack.userID === employeeId) {
          return manpack.manpack
        }
      })
      manpack.find(line => {
        if (line.productId === productId) {
          return line.qty
        } else {
          return 0
        }
      })
    }
  },

  manpacks: state => state.manpacks,

  manpackItems: state => state.manpackItems,

  addresses(state) {
    return state.addresses
  },
  initialAddressCount(state) {
    return state.initialAddressCount
  },
  addressesPosted(state) {
    return state.addressesPosted
  },
  expectedAddressCount(state) {
    return state.initialAddressCount + state.addressesPosted
  },
  stockOrder(state) {
    return state.stockOrder ? { ...state.stockOrder } : null
  },
  basket(state) {
    return [...state.basket]
  },
  shipMethods(state) {
    return state.shipMethods
  },
  instructions(state) {
    return state.instructions
  },
  toSaveBasket(state) {
    const manpack = _.cloneDeep(state.manpacks)
    manpack.forEach(pack => {
      pack.data = getSimpleItems(pack.data)
    })
    return {
      stock: getSimpleItems(state.basket),
      manpack
    }
  },
  paymentMethods(state) {
    return state.paymentMethods
  },
  verifyPrices(state) {
    return state.verifyPrices
  },
  selectedBasketType(state) {
    return state.selectedBasketType
  },
  hasVisitedBasket(state) {
    return state.hasVisitedBasket
  },
  consolidateDelivery(state) {
    return state.consolidateDelivery
  },
  splitFeeItem: state => state.splitFeeItem, // <-- ADD THIS GETTER
  punchoutLoadedBasket(state) {
    return state.punchoutLoadedBasket
  }
}

export const actions = {
// In store/modules/basket.js

// In store/modules/basket.js

async fetchSplitFeeItem({ commit }) {
  try {
    const response = await axios.get('/api/item', {
      params: {
        'internalId[$in]': ['5348768'],
        scope: 'item',
        includePricing: true
      }
    });

    const itemData = response.data?.data?.[0];

    if (itemData && itemData.costEstimate) {
      const feeItem = {
        id: itemData.internalId,
        name: itemData.displayName,
        price: parseFloat(itemData.costEstimate) || 0
      };
      commit('SET_SPLIT_FEE_ITEM', feeItem);
    } else {
      console.warn('API call succeeded, but the data array was empty.', response.data);
      commit('SET_SPLIT_FEE_ITEM', null);
    }
  } catch (error) {
    console.error("Caught an error while fetching split delivery fee item:", error);
    commit('SET_SPLIT_FEE_ITEM', null);
  }
},
  // Actions below are invoked by modify basket
  addToBasket(
    { commit },
    {
      employeeId = false,
      productId,
      qty,
      parentId = false,
      thumbnail,
      name,
      price,
      custombasket = false,
      options = []
    }
  ) {
    if (qty > 0) {

      commit('ADD_TO_BASKET', {
        employeeId: employeeId,
        productId: productId,
        qty: qty,
        parentId: parentId,
        thumbnail,
        name: name,
        price: price,
        custombasket: custombasket,
        options
      })
    } else {
      commit('REMOVE_FROM_BASKET', {
        employeeId: employeeId,
        productId: productId
      })
    }
  },
  removeFromBasket({ commit }, { productId, employeeId = false }) {

    commit('REMOVE_FROM_BASKET', {
      employeeId: employeeId,
      productId: productId
    })
  },
  updateBasket({ commit }, payload) {

    commit('UPDATE_BASKET', payload)
  },
  removeBasket({ commit }, payload) {
    commit('REMOVE_BASKET', payload)
  },
  updateBasketManpack(
    { commit },
    { employeeId, productId, qty, removeId = null, editing = false }
  ) {
    commit('updateBasketManpack', {
      employeeId: employeeId,
      productId: productId,
      removeId: removeId,
      qty: qty,
      editing: editing
    })
  },
  verifySavedBasket({ state, commit }) {
    for (let item of state.basket) {
      if (!isItemExists(item.productId, state.stockOrder)) {
        commit('REMOVE_FROM_BASKET', { productId: item.productId })
      }
    }

    for (let pack of state.manpacks) {
      for (let item of pack.data) {
        if (!isItemExists(item.productId, state.manpackItems)) {
          commit('REMOVE_FROM_BASKET', {
            productId: item.productId,
            employeeId: pack.employeeId
          })
        }
      }
    }
  },
  async submitOrder({ state, commit }, data = {}) {
    const promises = []

    if (state.basket.length) {

      const resultBasket = await axios.post(
        '/api/order',
        composeStockOrderData(state, data.stock)
      )

      if (resultBasket.data.threeDSUrl) {
        const creqInput = document.getElementById('form_creq')
        const sessionDataInput = document.getElementById('form_session_ata')

        // Set dummy values for the input fields
        creqInput.value = resultBasket.data.cReq
        sessionDataInput.value = resultBasket.data.transactionId

        //push data to the on page form and submit
        //this takes the user to opayo to handle the 3DS
        //once on opayo a POST request is sent back to my-smi
        var form = document.getElementById('3dsform')
        // Submit the form
        form.submit()
      } else {

        promises.push(resultBasket)
      }

      promises.push(resultBasket)
    }

    if (state.manpacks.length) {
      const resultManpack = await axios.post(
        '/api/order',
        composeManpackOrderData(state, data.manpack)
      )

      if (201 == resultManpack.status) {
        // layout fix
        setTimeout(() => {
          commit('REMOVE_BASKET', 'manpack')
        }, 1000)
        resultManpack.data.isManpack = true
      }
      promises.push(resultManpack)
    }

    commit('UPDATE_PAYMENTMETHOD', {
      signature: null,
      sessionkey: null,
      card: {},
      paymentInput: {
        name: '',
        cardNumber: '',
        expiryMonth: '',
        expiryYear: '',
        type: 'Card',
        cvc: ''
      }
    })

    if (promises.length) {
      return promises
    }
  },
  async finalizeApprovedOrder({ state, commit }) {
    const basketId = state.basketIdForApproval;
    // Check if there's an ID to process
    if (basketId) {
      try {
        // This is where you finally update the database flag
        await axios.patch(`/api/saved-basket/${basketId}`, {
          punchout_approved: 1
        });
        // Important: Clean up the state after the API call is successful
        commit('CLEAR_BASKET_ID_TO_APPROVE');
      } catch (error) {
        console.error("Failed to finalize punchout approval for basket ID:", basketId, error);
        // Even if this fails, we clear the ID to prevent retries on wrong orders.
        // You might want to add more robust error handling here, like notifying an admin.
        commit('CLEAR_BASKET_ID_TO_APPROVE');
      }
    }
  },
  async manpackFetchData({ state, dispatch, commit,rootState  }) {
    let { manpacks } = state
    let configurables = []

    manpacks = manpacks || []

    const id_employees = manpacks.map(e => {
      e.data = e.data || []
      configurables = [
        ...new Set(configurables.concat(e.data.map(o => parseInt(o.parentId))))
      ]

      return e.employeeId
    })

    const contactProducts = manpacks
      .map(
        pack => `${pack.employeeId}:${pack.data.map(o => o.parentId).join(',')}`
      )
      .join('|')

    if (!id_employees.length) {
      return
    }
    // Don't reset manpack items immediately - wait until new data is fetched to prevent flickering

    await Promise.all([
      dispatch(
        'manpack/fetchAndMergeEmployee',
        {
          'internalId[$in]': id_employees
        },
        { root: true }
      ),
      dispatch(
        'manpack/getContactBudgets',
        { ids: id_employees },
        { root: true }
      )
    ])
    const canViewManpack = _.get(
      rootState,
      'account.session.account.permissions',
      []
    ).includes('canViewManpack' && 'manpackOrders');
    // Fetch manpack data items only product that user has already selected
    if (canViewManpack) {

    const { data } = await axios.get('/api/item', {
      params: {
        scope: 'manpack',
        employees: id_employees,
        includePricing: true,
        includeFinished: true,
        includeChildren: true,
        includeAllocation: true,
        includeBudget: true,
        contactProducts: contactProducts,
        'internalId[$in]': configurables
      }
    })
    // Set manpack items
    commit('setManpackItems', data)}
  },
  async orderStockFetchData({ state, commit, rootState }) {
    const accessFullCatalogue = _.get(
      rootState,
      'account.session.account.permissions',
      []
    ).includes('fullCatalogue')

    const ids = _.uniq(state.basket.map(o => o.parentId))
    if (ids.length) {
      const { data } = await axios.get('/api/item', {
        params: {
          // Scope for permission checking, please don't override this one
          scope: accessFullCatalogue ? 'all' : 'my',
          'internalId[$in]': ids,
          includeChildren: true,
          includeFinished: true,
          includePricing: true,
          includeBudget: true
        }
      })

      commit('setStockOrder', data)
    }
  },
  async verifyPrices({ state, commit, rootState, dispatch }) {
    const accessFullCatalogue = _.get(
      rootState,
      'account.session.account.permissions',
      []
    ).includes('fullCatalogue')
    let anyFail = false
    const ids = _.uniq(state.basket.map(o => o.parentId))
    if (ids.length && !state.basket[0].custombasket) {
      const { data } = await axios.get('/api/item', {
        params: {
          // Scope for permission checking, please don't override this one
          scope: accessFullCatalogue ? 'all' : 'my',
          'internalId[$in]': ids,
          includeChildren: true,
          includeFinished: true,
          includePricing: true,
          includeBudget: true
        }
      })

      await data.forEach(obj1 => {
        // Find the matching object in the second array based on integerId
        const matchingObj2 = state.stockOrder.find(
          obj2 => obj2.integerId === obj1.integerId
        )

        // If a matching object is found, compare the prices
        if (matchingObj2) {
          if (obj1.price !== matchingObj2.price) {
            anyFail = true
          }
        } else {
          anyFail = true
        }
      })
    }

    let { manpacks } = state
    let configurables = []

    manpacks = manpacks || []

    const id_employees = manpacks.map(e => {
      e.data = e.data || []
      configurables = [
        ...new Set(configurables.concat(e.data.map(o => parseInt(o.parentId))))
      ]

      return e.employeeId
    })

    const contactProducts = manpacks
      .map(
        pack => `${pack.employeeId}:${pack.data.map(o => o.parentId).join(',')}`
      )
      .join('|')

    if (id_employees.length) {
      // Reset old data

      await Promise.all([
        dispatch(
          'manpack/fetchAndMergeEmployee',
          {
            'internalId[$in]': id_employees
          },
          { root: true }
        ),
        dispatch(
          'manpack/getContactBudgets',
          { ids: id_employees },
          { root: true }
        )
      ])
      // Fetch manpack data items only product that user has already selected
      const { data } = await axios.get('/api/item', {
        params: {
          scope: 'manpack',
          employees: id_employees,
          includePricing: true,
          includeFinished: true,
          includeChildren: true,
          includeAllocation: true,
          contactProducts: contactProducts,
          'internalId[$in]': configurables
        }
      })

      await data.forEach(obj1 => {
        // Find the matching object in the second array based on integerId
        const matchingObj2 = state.manpackItems.find(
          obj2 => obj2.integerId === obj1.integerId
        )

        // If a matching object is found, compare the prices
        if (matchingObj2) {
          if (obj1.price !== matchingObj2.price) {
            anyFail = true
          }
        } else {
          anyFail = true
        }
      })
    }

    commit('setVerifyPrices', anyFail)
  },

  async refreshPrices({ state, commit, rootState, dispatch }) {
    let anyFail = false
    const accessFullCatalogue = _.get(
      rootState,
      'account.session.account.permissions',
      []
    ).includes('fullCatalogue')

    const ids = _.uniq(state.basket.map(o => o.parentId))
    if (ids.length) {
      const { data } = await axios.get('/api/item', {
        params: {
          // Scope for permission checking, please don't override this one
          scope: accessFullCatalogue ? 'all' : 'my',
          'internalId[$in]': ids,
          includeChildren: true,
          includeFinished: true,
          includePricing: true,
          includeBudget: true
        }
      })
      commit('setStockOrder', data)
      await data.forEach(obj1 => {

        // Find the matching object in the second array based on integerId
        const matchingObj2 = state.stockOrder.find(
          obj2 => obj2.integerId === obj1.integerId
        )

        // If a matching object is found, compare the prices
        if (matchingObj2) {
          if (obj1.price !== matchingObj2.price) {
            anyFail = true
          }
        } else {
          anyFail = true
        }
      })
    }

    let { manpacks } = state
    let configurables = []

    manpacks = manpacks || []

    const id_employees = manpacks.map(e => {
      e.data = e.data || []
      configurables = [
        ...new Set(configurables.concat(e.data.map(o => parseInt(o.parentId))))
      ]

      return e.employeeId
    })

    const contactProducts = manpacks
      .map(
        pack => `${pack.employeeId}:${pack.data.map(o => o.parentId).join(',')}`
      )
      .join('|')

    if (id_employees.length) {
      await Promise.all([
        dispatch(
          'manpack/fetchAndMergeEmployee',
          {
            'internalId[$in]': id_employees
          },
          { root: true }
        ),
        dispatch(
          'manpack/getContactBudgets',
          { ids: id_employees },
          { root: true }
        )
      ])
      // Fetch manpack data items only product that user has already selected
      const { data } = await axios.get('/api/item', {
        params: {
          scope: 'manpack',
          employees: id_employees,
          includePricing: true,
          includeFinished: true,
          includeChildren: true,
          includeAllocation: true,
          contactProducts: contactProducts,
          'internalId[$in]': configurables
        }
      })

      // Set manpack items
      commit('setManpackItems', data)
      //TODO: check if this is needed, also, causes a bug if there are manpack items in the basket
      await data.forEach(obj1 => {
        // Find the matching object in the second array based on integerId
        const matchingObj2 = state.manpackItems.find(
          obj2 => obj2.integerId === obj1.integerId
        )

        // If a matching object is found, compare the prices
        if (matchingObj2) {
          if (obj1.price !== matchingObj2.price) {
            anyFail = true
          }
        } else {
          anyFail = true
        }
      })
    }

    commit('setVerifyPrices', anyFail)
  },
  async fetchAddresses({ state, commit }) {
    // Check if we have addresses cached and if the count matches expected
    const expectedCount = state.initialAddressCount + state.addressesPosted
    if (state.addresses.length && state.addresses.length >= expectedCount) {
      return
    }

    let addresses = await axios.get('/api/customer-address', {
      params: {
        $limit: 10000,
        'details.custrecord4.value[$ne]': true
      }
    })

    addresses = addresses.data.map(address => {
      address.value = address.internalId
      address.originLabel = address.label
      address.label = _.get(address, 'details.addrText', '')
      address.label = address.label.replace(/<br>/g, ' \n')
      address.searchAbleText = _.get(address, 'details.zip', '')
      address.selectedText = `${[address.details.addr1, address.details.addr2]
        .filter(o => o)
        .join(', ')}... ${_.get(address, 'details.zip', '')}`
      return address
    })

    commit('setAddresses', addresses)
  },
  async fetchShipMethods({ state, commit }) {
    if (state.shipMethods.length) {
      return
    }
    let methods = await axios.get('/api/carriage', {
      params: {
        'isinactive[$match]': false
      }
    })

    methods = methods.data.data.map(method => {
      method.value = method.internalId
      method.label = `${method.description} ${formatCurrency(
        method.shippingflatrateamount
      )}`
      return method
    })

    commit('setShipMethods', methods)
  },
  async sendReorder({ commit }, dataPost) {
    const { status, data } = await axios.post('/api/re-order', dataPost)

    if (status == 201) {
      // Standard basket
      if (data.stock) {
        data.stock.map(o => commit('ADD_TO_BASKET', o))
      } else {
        if (data.length == 0) return
        // Manpack basket
        data.map(o => {
          o.data.map(item =>
            commit('addManpackBasketItem', { employee: o.employeeId, item })
          )
        })
      }
    }

    return { status, data }
  },
  updatePaymentMethod({ commit }, data) {
    commit('UPDATE_PAYMENTMETHOD', data)
  },
  setSavedBasked({ commit }, data) {
    commit('loadSavedBasket', data)
  },
  setSelectedBasketType({ commit }, basketType) {
    commit('SET_SELECTED_BASKET_TYPE', basketType)
  },
  setHasVisitedBasket({ commit }, visited = true) {
    commit('SET_HAS_VISITED_BASKET', visited)
  },
  setConsolidateDelivery({ commit }, consolidate = true) {
    commit('SET_CONSOLIDATE_DELIVERY', consolidate)
  },
  resetBasketStore({ commit }) {
    commit('RESET_BASKET_STORE')
  },
    SET_APPROVED_ORDER_DETAILS(state, details) { // <-- ADD THIS
    state.approvedOrderDetails = details;
  },
  CLEAR_APPROVED_ORDER_DETAILS(state) { // <-- ADD THIS
    state.approvedOrderDetails = null;
  },
  setPunchoutLoadedBasket({ commit }, basketId) {
    commit('SET_PUNCHOUT_LOADED_BASKET', basketId)
  },
    SET_APPROVED_ORDER_ADDRESS_ID(state, addressId) {
    state.approvedOrderAddressId = addressId;
  },
  CLEAR_APPROVED_ORDER_ADDRESS_ID(state) {
    state.approvedOrderAddressId = null;
  }
}

export const mutations = {
  SET_SPLIT_FEE_ITEM(state, item) { // <-- ADD THIS MUTATION
    state.splitFeeItem = item;
  },
  ADD_TO_BASKET(state, payload) {
    const {
      employeeId = false,
      productId,
      qty,
      parentId = false,
      thumbnail,
      name,
      price,
      custombasket,
      options = []
    } = payload;

    const itemPayload = {
      productId,
      qty: parseInt(qty),
      parentId,
      thumbnail,
      name,
      price,
      custombasket,
      options
    };

    if (!employeeId) {
      const line = state.basket.find(line => line.productId === productId);

      if (!line) {
        state.basket.push(itemPayload);
      } else {
        line.qty += parseInt(qty);
      }
    } else {
      addManpackBasketItemToState(state, {
        employee: employeeId,
        item: itemPayload
      });
    }
  },
  SET_APPROVED_ORDER_DETAILS(state, details) {
    state.approvedOrderDetails = details;
  },
  CLEAR_APPROVED_ORDER_DETAILS(state) {
    state.approvedOrderDetails = null;
  },
  UPDATE_BASKET(state, payload) {
    if (payload.employeeId) {
      //update manpack
    } else {
      const exists = state.basket.find(o => o.productId == payload.productId)
      if (exists && exists.productId != payload.removeId) {
        // update standard basket
        state.basket = state.basket
          .map(item => {
            if (item.productId === payload.productId) {
              item.qty = parseInt(payload.qty) + parseInt(item.qty)
              item.editing = payload.editing || false
            }

            return item
          })
          .filter(item => item.productId != payload.removeId)
      } else {
        // update standard basket
        state.basket = state.basket.map(item => {
          if (item.productId === payload.removeId) {
            item.productId = payload.productId
            item.qty = parseInt(payload.qty)
            item.editing = payload.editing || false
          }

          return item
        })
      }
    }
  },

  REMOVE_FROM_BASKET: (state, { employeeId = false, productId }) => {
    // Check if manpack line
    if (!employeeId) {
      state.basket = state.basket.filter(item => item.productId !== productId)
    } else {
      state.manpacks = state.manpacks.filter(manpack => {
        if (manpack.employeeId == employeeId) {
          manpack.data = manpack.data.filter(
            item => item.productId != productId
          )

          return manpack.data.length > 0
        }

        return true
      })
    }
  },

  REMOVE_BASKET(state, type) {
    if (type === 'manpack') {
      state.manpacks = []
      state.instructions.manpack = {}
    } else if (type === 'stock') {
      state.basket = []
      state.instructions.stock = {}
    }
  },

  changeAllPacksAddress(state, addressId) {
    state.manpacks = state.manpacks.map(pack => {
      pack.addressId = addressId
      return pack
    })
  },
      SET_BASKET_ID_TO_APPROVE(state, basketId) {
    state.basketIdForApproval = basketId;
  },

  CLEAR_BASKET_ID_TO_APPROVE(state) {
    state.basketIdForApproval = null;
  },

  updateBasketManpack(
    state,
    { employeeId, productId, qty, removeId = null, editing = false }
  ) {
    state.manpacks = state.manpacks.map(empl => {
      if (employeeId == empl.employeeId) {
        const exists = empl.data.find(o => o.productId == productId)

        if (exists && exists.productId != removeId) {
          empl.data = empl.data
            .map(item => {
              if (item.productId == productId) {
                item.qty = parseInt(qty) + parseInt(item.qty)
                item.editing = editing
              }

              return item
            })
            .filter(item => item.productId != removeId)
        } else {
          // update standard basket
          empl.data = empl.data.map(item => {
            if (item.productId == removeId) {
              item.productId = productId
              item.qty = parseInt(qty)
              item.editing = editing
            }

            return item
          })
        }
      }

      return empl
    })
  },

  /**
   * addManpackBasketItem
   * @params integer employee
   * @params {} item
   **/
  addManpackBasketItem(state, payload) {
    addManpackBasketItemToState(state, payload);
  },

  setStockOrder(state, data) {
    state.stockOrder = data
  },

  setManpackItems(state, data) {
    state.manpackItems = data
  },
  setAddresses(state, data) {
    state.addresses = data
  },
  clearAddresses(state) {
    state.addresses = []
  },
  setInitialAddressCount(state, count) {
    state.initialAddressCount = count
  },
  setAddressesPosted(state, count) {
    state.addressesPosted = count
  },
  incrementAddressesPosted(state) {
    state.addressesPosted++
  },
  setShipMethods(state, data) {
    state.shipMethods = data
  },
  saveInstructions(state, data) {
    for (let key in data.data) {
      state.instructions[data.type][key] = data.data[key]
    }
    state.instructions = { ...state.instructions }
  },
  changeManpackLineData(state, data) {
    state.manpacks = state.manpacks.map(pack => {
      if (pack.employeeId === data.employeeId) {
        for (let key in data.data) {
          pack[key] = data.data[key]
        }
      }
      return pack
    })
    state.manpacks = [...state.manpacks]
  },
  loadSavedBasket(state, data) {
    const { stock, manpack } = data
    // if (instructionSchema.validate(instructions).valid) {
    //   state.instructions = data.instructions
    // } else {
    //   state.instructions = {
    //     stock: {},
    //     manpack: {}
    //   }
    // }
    if (stockOrderSchema.validate({ order: stock }).valid) {
      state.basket = stock
    } else {
      state.basket = []
    }
    if (manpackOrderSchema.validate({ order: manpack }).valid) {
      state.manpacks = manpack
    } else {
      state.manpacks = []
    }
  },
  UPDATE_PAYMENTMETHOD(state, data) {
    _.forEach(data, (value, key) => (state.paymentMethods[key] = value))
  },
  setVerifyPrices(state, data) {
    state.verifyPrices = data
  },
  SET_SELECTED_BASKET_TYPE(state, basketType) {
    state.selectedBasketType = basketType
  },
  SET_HAS_VISITED_BASKET(state, visited) {
    state.hasVisitedBasket = visited
  },
  SET_CONSOLIDATE_DELIVERY(state, consolidate) {
    state.consolidateDelivery = consolidate},
  SET_APPROVED_ORDER_ADDRESS_ID(state, addressId) {
    state.approvedOrderAddressId = addressId;
  },
  CLEAR_APPROVED_ORDER_ADDRESS_ID(state) {
    state.approvedOrderAddressId = null;
  },
  RESET_BASKET_STORE(state) {
    // Reset all basket-related data to initial state
    state.basket = []
    state.manpacks = []
    state.stockOrder = []
    state.manpackItems = []
    state.instructions = {
      stock: {},
      manpack: {}
    }
    state.addresses = []
    state.shipMethods = []
    state.customAddressSet = null
    state.paymentMethods = {
      type: 1,
      signature: null,
      card: {},
      sessionkey: null,
      paymentInput: {
        name: '',
        cardNumber: '',
        expiryMonth: '',
        expiryYear: '',
        type: 'Card',
        cvc: ''
      }
    }
    state.verifyPrices = true
    state.selectedBasketType = 'stock-order-basket'
    state.hasVisitedBasket = false
    state.consolidateDelivery = true
    state.basketIdForApproval = null
    state.punchoutLoadedBasket = null

  },
  SET_PUNCHOUT_LOADED_BASKET(state, basketId) {
    state.punchoutLoadedBasket = basketId
  }
}

function composeStockOrderData(state, additionalData) {
  const isPunchout = store.getters['account/isPunchoutSession']
  const hasPointsBudget = store.getters['account/hasPointsBudget']

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
  }

  const punchoutSessionCookie = getCookie('punchoutSession');

  // Create a map of savedItems by id to get itemPoints
  const savedItemsMap = {};
  if (additionalData.savedItems) {
    additionalData.savedItems.forEach(item => {
      savedItemsMap[item.id] = item;
    });
  }

  const data = {
    orderType: 'standard',
    items: state.basket.map(o => {
      const item = {
        internalId: o.productId,
        qty: parseInt(o.qty)
      };

      // Only add itemPoints if user has points budget
      if (hasPointsBudget) {
        let itemPoints = null;

        // First, check if basket item has budget.itemPoints from includeBudget
        if (o.budget && o.budget.itemPoints !== undefined && o.budget.itemPoints !== null) {
          itemPoints = o.budget.itemPoints;
        }
        // Fall back to savedItems if no budget info on basket item
        else {
          const savedItem = savedItemsMap[o.productId];
          if (savedItem && savedItem.itemPoints !== undefined && savedItem.itemPoints !== null) {
            itemPoints = savedItem.itemPoints;
          }
        }

        if (itemPoints !== null) {
          item.itemPoints = itemPoints;
        }
      }

      return item;
    }),
    punchoutSession: isPunchout,
    deliveryInstructions: {
      ...(additionalData.data.instructions || {})
    },
    fullOrder: additionalData.fullOrder,
    consolidateDelivery: additionalData.data.consolidateDelivery || false
  }

  if (additionalData.data.addressId) {
    data.addressId = additionalData.data.addressId
  }



  if (additionalData.data.customAddress) {
    data.customAddress = additionalData.data.customAddress
  }
  if (punchoutSessionCookie) {
    data.punchoutSession = punchoutSessionCookie
  }
  if (additionalData.data.stripeId) {
    data.stripeId = additionalData.data.stripeId;
    data.stripePaid = additionalData.data.stripePaid;
  }

  if (additionalData.data.budgetExceeded) {
    data.budgetExceeded = additionalData.data.budgetExceeded;
  }

  if (additionalData.data.approvalRequest) {
    data.approvalRequest = additionalData.data.approvalRequest;
  }

  if (additionalData.loadedBasket) {
    data.loadedBasket = additionalData.loadedBasket
  }

  // Include punchout loaded basket ID if exists
  if (state.punchoutLoadedBasket) {
    data.punchoutLoadedBasket = state.punchoutLoadedBasket
  }

  if (additionalData.savedItems) {
    data.savedItems = additionalData.savedItems
  }

  if (additionalData.data.shippingMethod) {
    data.shippingMethod = additionalData.data.shippingMethod
  }

  if (additionalData.data.chosenBasket) {
    data.chosenBasket = additionalData.data.chosenBasket
  }

  const payment = _.get(additionalData, 'data.paymentOptions', {})
  const paymentType = _.get(additionalData, 'data.paymentMethod.type')
  const paymentToken = _.get(additionalData, 'data.paymentMethod.signature')
  const paymentSession = _.get(additionalData, 'data.paymentMethod.sessionkey')
  const paymentCVC = _.get(
    additionalData,
    'data.paymentMethod.paymentInput.cvc'
  )
  let custentitypayment_method = _.get(
    payment,
    'value.$attributes.internalId',
    0
  )

  custentitypayment_method = parseInt(custentitypayment_method)
  if ([1, 2].includes(custentitypayment_method)) {
    if (paymentType == 2) {
      data.paymentMethod = {
        paymentToken,
        cvc: paymentCVC,
        custentitypayment_method,
        session: paymentSession
      }
    }
  }

  return data
}
function composeManpackOrderData(state, additionalData) {
  const isPunchout = store.getters['account/isPunchoutSession']

  const data = {
    orderType: 'manpack',
    packs: state.manpacks.map(pack => {
      const result = {
        contactId: pack.employeeId,
        items: pack.data.map(item => ({
          internalId: item.productId,
          qty: parseInt(item.qty)
        }))
      }
      if (pack.shippingMethod) {
        result.shippingMethod = pack.shippingMethod
      }
      if (pack.addressId) {
        result.addressId = pack.addressId
      } else if (additionalData?.data.addressId) {
        result.addressId = additionalData?.data.addressId
      }

      return result
    }),
    deliveryInstructions: {
      ...(additionalData.data.instructions || {})
    },
    fullOrder: additionalData?.fullOrder
  }

  if (additionalData?.data.customAddress) {
    data.customAddress = additionalData?.data.customAddress
  }

  if (additionalData?.data.approvalRequest) {
    data.approvalRequest = additionalData.data.approvalRequest;
  }

  // --- THIS BLOCK IS THE FIX ---
  if (additionalData?.data.stripeId) {
    data.stripeId = additionalData.data.stripeId;
    data.stripePaid = additionalData.data.stripePaid;
  }
  // -------------------------

  const payment = _.get(additionalData, 'data.paymentOptions', {})
  // TODO: There are two options from SMI frontend
  // 1: Trade account
  // 2: Instant payment
  const paymentType = _.get(additionalData, 'data.paymentMethod.type')
  const paymentToken = _.get(additionalData, 'data.paymentMethod.signature')
  const paymentCVC = _.get(
    additionalData,
    'data.paymentMethod.paymentInput.cvc'
  )
  const paymentSession = _.get(additionalData, 'data.paymentMethod.sessionkey')

  // TODO: There are three options from the Netsuite:
  // 1: Account & Card Payment
  // 2: Account Payment
  // 3: Card Payment Only
  let custentitypayment_method = _.get(
    payment,
    'value.$attributes.internalId',
    0
  )

  custentitypayment_method = parseInt(custentitypayment_method)
  if ([1, 2].includes(custentitypayment_method)) {
    if (paymentType == 2) {
      data.paymentMethod = {
        paymentToken,
        cvc: paymentCVC,
        custentitypayment_method,
        session: paymentSession
      }
    }
  }

  return data
}

function getSimpleItems(items) {
  const validFields = ['qty', 'productId', 'parentId', 'removeId']
  return items.map(item => {
    const cloneItem = { ...item }
    for (let key in cloneItem) {
      if (!validFields.includes(key)) {
        delete cloneItem[key]
      }
    }
    return cloneItem
  })
}

function isItemExists(id, items) {
  return !!items.find(item => {
    return (
      item.internalId === id ||
      (Array.isArray(item.simples) &&
        item.simples.find(o => o.internalId === id))
    )
  })
}

export default {
  namespaced: true, // optional, if you want namespacing
  state,
  mutations,
  actions,
  getters,
};